import { useEffect, useState } from 'react'

import { FC, invalidateQuery, useCQuery } from '../../../../Services'
import { showToast } from '../../../../utils/toast'

export const useUser = (userId) => {
  const [user, setUser] = useState()
  const { data, isSuccess } = useCQuery(['user', userId])

  useEffect(() => {
    isSuccess && setUser(data)
  }, [isSuccess, data])

  const setUserProp = (prop, value) => setUser({ ...user, [prop]: value })

  return [user, setUserProp, isSuccess]
}

export const saveUser = async (user) => {
  if (user.id === 'new') {
    delete user.id
    try {
      const res = await FC.service('users').create({ ...user })
      invalidateQuery(['user', 'users'])
      showToast('success', 'Success', 'Salvataggio effettuato')
      return res
    } catch (error) {
      showToast('error', 'Errore', error?.message || 'Errore durante il salvataggio')
      return false
    }
  }
  if (!user.id && user.id !== 0) {
    showToast('error', 'Errore', 'ID utente non valido, impossibile aggiornare')
    return false
  }
  try {
    const { id, createdAt, updatedAt, ...data } = user
    const res = await FC.service('users').patch(id, data)
    invalidateQuery(['user', 'users'])
    showToast('success', 'Success', 'Salvataggio effettuato')
    return res
  } catch (error) {
    showToast('error', 'Errore', error?.message || 'Errore durante il salvataggio')
    return false
  }
}

export const deleteUser = async (userId) => {
  try {
    const res = await FC.service('users').remove(userId)
    invalidateQuery(['user', 'users'])
    showToast('success', 'Success', 'Eliminazione effettuata')
    return res
  } catch (error) {
    showToast('error', 'Errore', error?.message || "Errore durante l'eliminazione")
    return false
  }
}
